import React, { useState } from 'react';

export const History: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'runs' | 'people'>('runs');

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">History</h1>

        <div className="bg-white shadow rounded-lg">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              <button
                onClick={() => setActiveTab('runs')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'runs'
                    ? 'border-coffee-500 text-coffee-600'
                    : 'border-transparent text-gray-500'
                }`}
              >
                Runs
              </button>
              <button
                onClick={() => setActiveTab('people')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'people'
                    ? 'border-coffee-500 text-coffee-600'
                    : 'border-transparent text-gray-500'
                }`}
              >
                People
              </button>
            </nav>
          </div>

          <div className="p-6">
            {activeTab === 'runs' && (
              <div className="text-center py-12">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Run History Coming Soon
                </h3>
                <p className="text-gray-600">
                  View past coffee runs with delegation features.
                </p>
              </div>
            )}

            {activeTab === 'people' && (
              <div className="text-center py-12">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  People & Usuals Coming Soon
                </h3>
                <p className="text-gray-600">
                  View frequent participants and their usual orders.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
